const defaultMergeFunction = (_existing: unknown, incoming: unknown) => incoming;

export { defaultMergeFunction };
